<template>
  <div class="card">
    <div class="card-body">
      <div class="input-group">
        <textarea type="text" class="form-control" placeholder="Frage" v-model="questionData.question"/>
      </div>
      <br>
      <div class="input-group answer" v-for="answer in questionData.answers">
        <input type="text" class="form-control" placeholder="Antwort" v-model="answer.text"/>
        <button :class="{btn:true,  'btn-danger':!answer.choice, 'btn-success':answer.choice}" @click="selectAnswer(answer)">
        </button>


      </div>
    </div>
    <div class="card-footer" layout="row center-center">
      <button class="btn btn-sm btn-danger" self="left" @click="remove">X</button>
      <button class="btn btn-sm btn-success" self="right" @click="save">Speichern</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "question",
    props: ['questionData'],
    computed: {
      answers: function() {

      }
    },
    methods: {
      selectAnswer(answer) {
        const data = this.$props.questionData.answers;
        console.log(data);
        for (let i in data) {
          const a = data[i];
          if (a === answer) {
            a.choice = true;
          } else {
            a.choice = false;
          }
        }
      },
      save() {
        this.$emit('onSave', this.$props.questionData);
      },
      remove() {
        const a = confirm("Frage löschen?");
        if (a) this.$emit('onDelete', this.$props.questionData);
      }
    },
    mounted() {

    }
  }
</script>

<style scoped>
  .answer {
    margin-bottom: 0.3rem;
  }
  .card {
    border: solid 1px;
    border-color: grey;
  }
</style>



// WEBPACK FOOTER //
// src/components/quiz/Question.vue